<template>
  <div>

    <el-row>
      <el-col :span="24">
        <!--      搜索视图      -->
        <search
          :searchForm="searchForm"
          :operatorForSelect="operatorForSelect"
          :operatorTree="operatorTree"
          :searchLoading="searchLoading"
          @submitSearchForm="submitSearchForm"
          ref="searchForm"
        >
        </search>
        <el-form>
          <el-col :span="2" class="diy-class">
            <el-form-item>
              <el-button size="mini" type="primary" @click="pileAdd" icon="el-icon-plus" class="el-btn" >
                {{ $t('paramMonitor.add') }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-form>
        <!--列表数据-->
        <!--      列表组件       -->
        <list
          :pileDataTable="pileDataTable"
          :listLoading="listLoading"
          @pileEdit="pileEdit"
          @pileDelete="pileDelete"
        ></list>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparam" @callFather="changePage"></Pagination>
      </el-col>
    </el-row>
    <!-- 编辑组件 -->
    <add
      :editForm="editForm"
      :editFormVisible="editFormVisible"
      :operatorForSelect="operatorForSelect"
      :operatorTree="operatorTree"
      :editSubmitLoading="editSubmitLoading"
      :yesNoEnum="enumData.yesNoEnum"
      :scooterRateTypeEnum="enumData.scooterRateTypeEnum"
      @closeEditForm="closeEditForm"
      @editSubmit="editSubmit"
    ></add>

  </div>
</template>

<script>
  import Pagination from '@/module/operatingCenter/component/Pagination.vue';
  import commonApi from '@/module/resourceCenter/api/commonApi';
  import api from '../../api/scooterRateApi.js';
  import search from "./search.vue";
  import list from "./list.vue"
  import add from "./add.vue";

  export default {
    name: 'deviceManager',
    data() {
      return {
        enumData: [{
          yesNoEnum:'',
          scooterRateTypeEnum:'',
        }],
        operatorForSelect: '',
        operatorTree: [],
        showFilters: true,
        listLoading: false,
        pileDataTable: [{}],
        // 多选集合
        pileDataSelection: [],
        // 查询
        searchLoading: false,
        searchFormVisible: false,
        searchForm: {// 未初始化不传递参数，影响后台接查询
        },
        // 编辑
        editFormVisible: false,
        editSubmitLoading: false,
        editForm: {
          scooterRateDetail:{},
          scooterRateDetailList:{}
        },
        formLabelWidth: '150px',
        // 分页参数
        pageparam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
      };
    },
    created: function () {
      if(this.editForm.type == null){
        this.editForm = {
          type : {
            code : ''
          }
        };
      }
      this.loadSelectItem();
    },
    methods: {

      // 加载下拉框
      loadSelectItem() {
        // 运营商下拉框
        commonApi.getOperatorsTree().then((res) => {
          if (res.code === 0) {
            this.operatorTree = res.data;
          }
        });
        //  加载枚举类
        api.getEnum().then((res) => {
          this.enumData.yesNoEnum = JSON.parse(res.yesNoEnum);
          this.enumData.scooterRateTypeEnum = JSON.parse(res.scooterRateTypeEnum);
        });
      },

      resetSearchForm() {
        this.searchForm = {}
      },
      submitSearchForm() {
        this.$refs.searchForm.$children[0].validate((valid) => {
          if (!valid) {
            return;
          }
          this.searchLoading = true;
          this.listLoading = true;
          this.pageparam.t = this.searchForm;
          let param = Object.assign({}, this.pageparam);
          api.getPage(param).then((res) => {
            if (res.code === 0) {
              this.pageparam.total = res.data.total;
              this.pileDataTable = res.data.list;
            } else {
              // this.$message.error(res.message);
            }
            this.searchLoading = false;
            this.listLoading = false;
          });
        })
      },
      closeEditForm(){
        this.editFormVisible = false
      },
      pileAdd() {
        this.$nextTick(() => {
          this.editFormVisible = true;
          this.editForm = Object.assign({});
          if(this.editForm.scooterRateDetail){
            this.editForm.electricPrice = this.editForm.scooterRateDetail.electricPrice;
          }
          this.editForm = {
            scooterRateDetailList:[{
              powerMax: '',
              electricPrice: '',
              servicePrice: ''
            }],
            type : {
              code : ''
            }
          };
        });
      },
      pileEdit(index, row) {
        this.editFormVisible = true;
        this.editForm = Object.assign({}, row);
        if(this.editForm.scooterRateDetail){
          this.editForm.electricPrice = this.editForm.scooterRateDetail.electricPrice;
        }
      },
      editSubmit(editForm) {
        editForm.validate((valid) => {
          if (!valid) {
            return;
          } else {
            this.$confirm(this.$t('deviceControl.AreYouSureToSubmit'), this.$t('deviceControl.prompt'), {}).then(() => {
              this.editSubmitLoading = true;
              if(Array.isArray(this.editForm.operatorId)){
                this.editForm.operatorId = this.editForm.operatorId[0];
              }
              if(this.editForm.type.code){
                this.editForm.type = this.editForm.type.code;
              }
              if(this.editForm.electricPrice){
                this.editForm.scooterRateDetail = {
                  electricPrice : this.editForm.electricPrice
                }
              }
              console.log("保存数据：" + JSON.stringify(this.editForm));
              let param = JSON.stringify(this.editForm);
                api.sava(param).then((res) => {
                  this.editSubmitLoading = false;
                  if (res.code === 0) {
                    this.editFormVisible = false;
                    this.submitSearchForm();
                  } else {

                  }
                }).catch((error) => {
                  this.editSubmitLoading = false;
                });
            });
          }
        })
      },
      pileDelete(index, row) {
        this.$confirm(this.$t('que-ding-yao-shan-chu') + row.name + this.$t('ma-0'), this.$t('alaramMonitor.message5'), {
          confirmButtonText: this.$t('deviceControl.confirm'),
          cancelButtonText: this.$t('alaramMonitor.cancel'),
          type: 'warning'
        })
          .then(() => {
            api.delete(row.id).then((res) => {
              if (res.code === 0) {
                this.$message({
                  message: res.message,
                  type: 'success'
                });
                this.submitSearchForm();
              } else {
                this.$message.error(res.message);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('alaramMonitor.message8')
            });
          });
      },
      changePage() {
        this.submitSearchForm();
      },
    },
    components: {
      Pagination,
      search,
      list,
      add
    },
    mounted: function () {
      this.submitSearchForm();
    },
    filters: {
      statusFilter(runStatus) {
        const statusMap = {
          0: 'success',
          1: 'info',
          2: 'danger',
          3: 'warning'
        }
        return statusMap[runStatus]
      }
    }
  };
</script>

<style lang="less" scoped>
  .el_search {
    background-color: teal;
    color: white;
  }

  .el_clear {
    background-color: darkorange;
    color: white;
  }
  /deep/.el-dialog{
    width: 900px;
  }
  /deep/ .edit_form, /deep/ .detail_form, /deep/ {
    height: 600px;
    overflow: auto;

    .el-form-item__label {
      color: rgba(0, 0, 0, 0.47);
    }
  }
  /deep/ .diy-class {
    .el-form-item__content {
      line-height: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/scooterRateManager/scooterRate.vue